// extracted by mini-css-extract-plugin
export default {"change_page_icon_next":"Paginator_change_page_icon_next__7Aba3","change_page_icon_prev":"Paginator_change_page_icon_prev__7mZ10"};